<div class="ngx-dialog goreact-modal ai-trial-course-selector-dialog">
  <div class="goreact-modal-header">
    <h4 class="modal-title">
      <span class="full-text" translate="ai-trial-course-selector-dialog_title"></span>
      <span class="shortened-text" translate="ai-trial-course-selector-dialog_title-shortened"></span>
    </h4>
    <button type="button" class="close-btn" (click)="close()" [attr.aria-label]="'common_close' | translate">
      <i class="ficon-app-x"></i>
    </button>
  </div>
  <div class="goreact-modal-body" [formGroup]="form" #content>
    <img alt="" src="https://staticassets.goreact.com/ai-trial-introduction.gif" />
    <p [innerHTML]="'ai-trial-course-selector-dialog_message' | translate"></p>

    <mat-form-field appearance="outline" class="folder-list">
      <mat-label>{{'common_course' | translate}}</mat-label>
      <mat-select
        formControlName="folder"
        [disabled]="isLti()"
        disableOptionCentering
        panelClass="offsetPanel">
        <mat-select-trigger>
          {{ displayFolderName() }}
        </mat-select-trigger>
        @for (folder of folders; track folder) {
          <mat-option [value]="folder.group_id">
            <span>{{ folder.name }}</span>
            @if (isAboutToExpire(folder)) {
              <span class="expire-label">{{ getExpireDate(folder) }}</span>
            }
          </mat-option>
        }
      </mat-select>
      <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
      @if (form.controls.folder.hasError('required')) {
        <mat-error>{{'ai-trial-course-selector-dialog_folder-error' | translate}}</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="goreact-modal-footer">
    @if (!isLti()) {
      <button
        type="button"
        class="link-btn add-btn goreact-btn create-folder-btn"
        [disabled]="isCreating$ | async"
        (click)="openCreateCoursePanel()">
        {{ 'folders_view-create_button' | translate }}
      </button>
    }
    <button
      type="button"
      class="tertiary-btn goreact-btn cancel-btn"
      (click)="close()">
      {{'common_cancel' | translate}}
    </button>
    <button
      type="button"
      class="primary-btn goreact-btn submit-btn"
      (click)="startTrial()"
      [focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}">
      {{ 'ai-trial-course-selector-dialog_submit-btn' | translate }}
    </button>
  </div>
</div>
